class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener(
        'submit',
        this.prepareSearchFormForSubmit.bind(this)
      );
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  isSkuSearchTerm(value) {
    return /^[A-Za-z]{2}[A-Za-z0-9_-]*\d$/.test(value.trim());
  }

  buildSearchQuery(value) {
    const searchTerm = value.trim();
    return this.isSkuSearchTerm(searchTerm)
      ? `variants.sku:${searchTerm}*`
      : searchTerm;
  }

  getOrCreateHiddenInput(name) {
    let input = this.input.form.querySelector(`input[name="${name}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.skuSearchDynamic = 'true';
      this.input.form.appendChild(input);
    }

    return input;
  }

  removeDynamicHiddenInput(name) {
    this.input.form
      .querySelector(`input[name="${name}"][data-sku-search-dynamic="true"]`)
      ?.remove();
  }

  prepareSearchFormForSubmit() {
    if (this.querySelector('[aria-selected="true"] a')) return;

    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) return;

    const isSkuSearch = this.isSkuSearchTerm(searchTerm);
    const prefixInput = this.input.form.querySelector(
      'input[name="options[prefix]"]'
    );

    if (prefixInput) prefixInput.value = isSkuSearch ? 'none' : 'last';

    if (isSkuSearch) {
      this.input.value = this.buildSearchQuery(searchTerm);
      this.getOrCreateHiddenInput('type').value = 'product';
    } else {
      this.removeDynamicHiddenInput('type');
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
